import type { Appointments } from "@/lib/appointments"

import type { BookingSummaryProps } from "@/components/Booking/BookingSummary"
import { SummaryBlock } from "@/components/Booking/SummaryBlock"

import { LocationIcon } from "@/constants/icons"

type LocationProps = {
  address_1: Appointments.AppointmentDetails[`address_1`]
  address_2: Appointments.AppointmentDetails[`address_2`]
  post_code: Appointments.AppointmentDetails[`post_code`]
  practice: Appointments.AppointmentDetails[`practice`]
  style: BookingSummaryProps[`style`]
}

export const Location = ({
  address_1,
  address_2,
  post_code,
  practice,
  style,
}: LocationProps) => {
  return (
    <SummaryBlock style={style} title={`Location`} icon={LocationIcon}>
      <p>{practice}</p>
      {address_1 && (
        <address className={`text-sm not-italic sm:text-lg`}>
          {address_1}
          {address_2 && <>, {address_2}</>}
          {post_code && <>, {post_code}</>}
        </address>
      )}
    </SummaryBlock>
  )
}
